import { Icon } from '@iconify/react';
import { IconButton } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import DialogEditarEnvio from './DialogEditarEnvio';

function EditarEnviosButton({ data }) {
  const [openDialog, setOpenDialog] = useState(false);
  const { id, payment_id, rate_provider, trackingNumber, provider, oneRequest, label_code, tracking_code } = data;
  const navigate = useNavigate();

  const showDetailsHandler = () => {
    navigate(
      `/dashboard/cotizaciones/administracion?id=${id}&payment_id=${payment_id}&oneRequest=${oneRequest}&provider=${provider}&paqueteria=${rate_provider}&codigo=${trackingNumber}&tracking_code=${tracking_code}`
    );
  };
  return (
    <>
      <IconButton
        size="small"
        onClick={() => {
          setOpenDialog(true);
          showDetailsHandler();
        }}
      >
        <Icon icon="eva:more-vertical-fill" />
      </IconButton>
      <DialogEditarEnvio open={openDialog} onClose={setOpenDialog} data={data} />
    </>
  );
}

export default EditarEnviosButton;
